
import { createReducer } from '../../app/common/util/reducerUtil';
import {
  UPDATE_NAME,
  UPDATE_PROFILE_PASSWORD,
} from './userConstants';

const initialState = {};

export const updateName = (state, payload) => {
  return {
    ...state,
    name: payload,
  }
}

export const updateProfilePassword = (state, payload) => {
  return {
    ...state,
    password: payload,
  }
}

export default createReducer(initialState, {
  [UPDATE_NAME]: updateName,
  [UPDATE_PROFILE_PASSWORD]: updateProfilePassword,
});